import React from 'react'
import { Button, Group, Select } from '@common/ui'

export type GroupHeaderProps = {
  operator: 'AND' | 'OR'
  onOperatorChange: (newOperator: 'AND' | 'OR') => void
  onToggleNegation: () => void
  isNegated: boolean
}

const GroupHeader: React.FC<GroupHeaderProps> = ({ operator, onOperatorChange, onToggleNegation, isNegated }) => (
  <Group gap="xs" align="center" mb="xs">
    <Select
      value={operator}
      onChange={(value) => value && onOperatorChange(value as 'AND' | 'OR')}
      data={['AND', 'OR']}
      size="sm"
      style={{ width: 100 }}
    />
    <Button variant="subtle" size="compact-xs" onClick={onToggleNegation}>
      {isNegated ? 'Un-Negate' : 'Negate'}
    </Button>
  </Group>
)

export default GroupHeader
